export default "__VITE_ASSET__b28d862d__"